import React from 'react';
import SMConst from 'lib/SMConst';

class SMFormSubmitButton extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      display: SMConst.Display.Visible,
    };
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({display: nextProps.display});
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.display == SMConst.Display.Loading &&
        prevState.display != SMConst.Display.Loading) {
      $(this.refs.submit).startLoading({
        color: "#fff",
        radius: 14,
        strokeWidth: 3,
        modalOpacity: 0,
      });
    }
    if (prevState.display == SMConst.Display.Loading &&
        this.state.display != SMConst.Display.Loading) {
      $(this.refs.submit).stopLoading();
    }
  }
  
  render() {
    let input = "";
    if (this.state.display == SMConst.Display.Loading) {
      input = <input name={this.props.name} className={this.props.options.className + " button-disabled"} type="submit" value="" />;
    } else {
      input = <input name={this.props.name} className={this.props.options.className} type="submit" value={this.props.title} />;
    }
    return (
      <span ref="submit">{input}</span>
    );
  }
}

SMFormSubmitButton.defaultProps = {
  options: {
    className: ""
  },
};

export default SMFormSubmitButton;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormSubmitButton.jsx